import http from "../http"

export default class SportService
{
  static Active = async() => {
    return await http().get('Sport')
  }
}